import { z } from 'zod';

import { entityIdSchema, isoDateTimeSchema } from './common.js';

export const auditEventSchema = z.object({
  id: entityIdSchema,
  actorId: entityIdSchema.nullable(),
  action: z.string().trim().min(1).max(160),
  entityType: z.string().trim().min(1).max(120),
  entityId: entityIdSchema.nullable(),
  occurredAt: isoDateTimeSchema,
  result: z.enum(['success', 'failure']),
  details: z.record(z.string(), z.unknown()),
});

export const migrationModeSchema = z.enum([
  'inspect',
  'backup',
  'dry-run',
  'migrate',
  'verify',
  'rollback',
]);

export const migrationReportSchema = z.object({
  migrationId: z.string().min(1),
  mode: migrationModeSchema,
  startedAt: isoDateTimeSchema,
  completedAt: isoDateTimeSchema,
  sourceSchema: z.string().min(1),
  targetSchema: z.literal('63.0.0'),
  tableCountsBefore: z.record(z.string(), z.number().int().nonnegative()),
  tableCountsAfter: z.record(z.string(), z.number().int().nonnegative()),
  anomalies: z.array(z.string()),
  backupId: entityIdSchema.nullable(),
  backupSha256: z
    .string()
    .regex(/^[a-f0-9]{64}$/i)
    .nullable(),
  destructiveStatements: z.literal(0),
});
